import React from "react";
import "../../CSS/CrownCss/EgzostFan.css";

const egzostData = [
  {
    title: "EF-1",
    controls: [
      { label: "On Off", value: "OFF" },
      { label: "Çalışma Durum", value: "OFF" },
      { label: "Arıza Durum", value: "NORMAL" },
      { label: "Pako Durum", value: "Auto" },
    ],
  },
  {
    title: "EF-2",
    controls: [
      { label: "On Off", value: "OFF" },
      { label: "Çalışma Durum", value: "OFF" },
      { label: "Arıza Durum", value: "NORMAL" },
      { label: "Pako Durum", value: "Auto" },
    ],
  },
  {
    title: "EF-3",
    controls: [
      { label: "On Off", value: "OFF" },
      { label: "Çalışma Durum", value: "OFF" },
      { label: "Arıza Durum", value: "NORMAL" },
      { label: "Pako Durum", value: "Auto" },
      { label: "Fr.Konv Sinyali", value: "0 %" },
      { label: "Damper On Off", value: "OFF" },
      { label: "Damper Durum", value: "OFF" },
    ],
  },
  {
    title: "EF-4",
    controls: [
      { label: "On Off", value: "OFF" },
      { label: "Çalışma Durum", value: "OFF" },
      { label: "Arıza Durum", value: "NORMAL" },
      { label: "Pako Durum", value: "Auto" },
      { label: "Fr.Konv Sinyali", value: "0 %" },
      { label: "Damper On Off", value: "OFF" },
      { label: "Damper Durum", value: "OFF" },
    ],
  },
  {
    title: "EF-5",
    controls: [
      { label: "On Off", value: "OFF" },
      { label: "Çalışma Durum", value: "OFF" },
      { label: "Arıza Durum", value: "NORMAL" },
      { label: "Pako Durum", value: "Auto" },
      { label: "Fr.Konv Sinyali", value: "0 %" },
      { label: "Damper On Off", value: "OFF" },
      { label: "Damper Durum", value: "OFF" },
    ],
  },
  {
    title: "EF-6",
    controls: [
      { label: "On Off", value: "OFF" },
      { label: "Çalışma Durum", value: "OFF" },
      { label: "Arıza Durum", value: "NORMAL" },
      { label: "Pako Durum", value: "Auto" },
      { label: "Fr.Konv Sinyali", value: "0 %" },
      { label: "Damper On Off", value: "OFF" },
      { label: "Damper Durum", value: "OFF" },
    ],
  },
  {
    title: "EF-7",
    controls: [
      { label: "On Off", value: "OFF" },
      { label: "Çalışma Durum", value: "OFF" },
      { label: "Arıza Durum", value: "NORMAL" },
      { label: "Pako Durum", value: "Auto" },
      { label: "Fr.Konv Sinyali", value: "0 %" },
      { label: "Damper On Off", value: "OFF" },
      { label: "Damper Durum", value: "OFF" },
    ],
  },
  {
    title: "EF-8",
    controls: [
      { label: "On Off", value: "OFF" },
      { label: "Çalışma Durum", value: "OFF" },
      { label: "Arıza Durum", value: "NORMAL" },
      { label: "Pako Durum", value: "Auto" },
      { label: "Fr.Konv Sinyali", value: "0 %" },
      { label: "Damper On Off", value: "OFF" },
      { label: "Damper Durum", value: "OFF" },
    ],
  },
];

const EgzostFan = () => {
  return (
    <section className="section_egzost">
      <div className="egzosttop">
        <div>EGZOST FANLARI</div>
      </div>

      <div className="bottom_egzost">
        {egzostData.map((egzost, index) => (
          <div key={index} className="rows">
            <div className="left">
              <div className="lefttitle">{egzost.title}</div>
            </div>
            <div className="right">
              <div className="right_top">
                {egzost.controls.slice(0, 4).map((control, idx) => (
                  <div key={idx} className="righttop">
                    {control.label}
                  </div>
                ))}
              </div>
              <div className="right_bottom">
                {egzost.controls.slice(0, 4).map((control, idx) => (
                  <div key={idx} className="control-value">
                    {control.value}
                  </div>
                ))}
              </div>
              <div className="damper_section">
                {egzost.controls.slice(4).map((control, idx) => (
                  <div key={idx} className="damper-control">
                    <span className="damper-label">{control.label}</span>
                    <span className="damper-value">{control.value}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default EgzostFan;
